export const FILE_QUEUE_START = "FILE_QUEUE_START";
export const FILE_QUEUE_END = "FILE_QUEUE_END";
export const FILE_QUEUE_CLEAR = "FILE_QUEUE_CLEAR";
export const FILE_UPDATE_START = "FILE_UPDATE_START";
export const FILE_UPDATE_END = "FILE_UPDATE_END";
export const FILE_UPDATE_CLEAR = "FILE_UPDATE_CLEAR";
export const FILE_URL_COPIED = "FILE_URL_COPIED";
export const ALERT = "ALERT";
